module.exports = __webpack_public_path__ + "img/jibie_top3.e8020d0f.png";